import { Building2, Contact, FileText } from 'lucide-react';

import type { RouteListItem } from '@/types';

export const competitorsSubNav: RouteListItem[] = [
  {
    path: '/competitors/$id',
    icon: Building2,
    name: 'Competitor',
    auditKey: 'competitor/profile',
  },
  {
    path: '/competitors/$id/contacts',
    icon: Contact,
    name: 'Contacts',
    auditKey: 'competitor/contacts',
  },
  {
    path: '/competitors/$id/associated-companies',
    icon: Building2,
    name: 'Associated Companies',
    auditKey: 'competitor/associated-companies',
  },
  {
    path: '/competitors/$id/notes',
    icon: FileText,
    name: 'Notes',
    auditKey: 'competitor/notes',
  },
];
